<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
@if (iconDimensions$|async; as dims) {
<svg [attr.width]="dims.width" [attr.height]="dims.height">
    @for (style of classConfig.styles; track style) {
        <g>
            @switch (redlineConfig.type) {
                @case ('line') {
                    <polyline [attr.points]="getLinePoints(dims.width, dims.height)"
                              [attr.fill]="style.fill && style.fill.color ? style.fill.color : 'none'"
                              [attr.stroke]="style.stroke ? style.stroke.color : null"
                              [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                              [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
                    />
                }
                @case ('point') {
                    @switch (style.type) {
                        @case ('point-circle') {
                            <circle
                                [attr.r]="style.radius"
                                [attr.cx]="dims.width / 2" [attr.cy]="dims.height / 2"
                                [attr.fill]="style.fill ? style.fill.color : 'none'"
                                [attr.stroke]="style.stroke ? style.stroke.color : null"
                                [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                                [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
                            ></circle>
                        }
                        @case ('point-star') {
                            <polygon
                                [attr.fill]="style.fill ? style.fill.color : 'none'"
                                [attr.stroke]="style.stroke ? style.stroke.color : null"
                                [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                                [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
                            ></polygon>
                        }
                        @case ('point-icon') {
                            <image [attr.href]="style.src"
                                   [attr.width]="dims.width" [attr.height]="dims.height"
                            ></image>
                        }
                    }
                }
            }
        </g>
    }
</svg>
}